module.exports = __webpack_public_path__ + "img/your-boxes.1bbfde3a.svg";